interface JsonLdProps {
  mainEntity: any
}

export default function FaqStructured({ mainEntity }: JsonLdProps) {
  const Faq = JSON.stringify({
    '@context': 'http://schema.org',
    '@type': 'FAQPage',
    ...mainEntity,
  })

  return (
    // eslint-disable-next-line react-dom/no-dangerously-set-innerhtml
    <script
      id='FAQPage'
      type='application/ld+json'
      dangerouslySetInnerHTML={{ __html: Faq }}
    />
  )
}
